/**
 * Service/Dd (Web and App Security) Controller
 *
 * Displays information about Web and App Security orders (formerly DDoS Protection)
 */

// the constructor for this object
function ServiceDdController() { }

// the object
ServiceDdController.prototype = {
    constructor: ServiceDdController,
    
    // the base order id
    baseOrderId: false,
    
    // the cloudflare zone id
    zoneId: false,
    
    // the pie chart for ssl traffic
    sslChart: false,
    
    // store the unique visitors chart object here
    visitorsChart: false,
    // a convertor for threat types to human readable
    
    threatTypes: {
        "all": "All",
        "bic.ban.unknown": "Bad browser",
        "hot.ban.unknown": "Blocked hotlink",
        "macro.ban.unknown": "Bad IP",
        "macro.chl.captchaErr": "Captcha Error",
        "macro.chl.captchaFail": "Human Challenged",
        "macro.chl.captchaNew": "New CAPTCHA (CF)",
        "macro.chl.jschlErr": "Bot Request",
        "macro.chl.jschlFail": "Browser Challenged",
        "macro.chl.jschlNew": "Challenged threat",
        "unclassified": "Unclassified",
        "user.ban.ctry": "Country block",
        "user.ban.ip": "IP block (user)",
        "user.ban.ip6": "IPv6 block (user)",
        "user.ban.ip6r32": "IPv6 range block (/32)",
        "user.ban.ip6r48": "IPv6 range block (/48)",
        "user.ban.ip6r64": "IPv6 range block (/64)",
        "user.ban.ipr16": "IP range block (/16)",
        "user.ban.ipr24": "IP range block (/24)",
        "user.chl.captchaNew": "New CAPTCHA (user)"
    },
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // register charts 
        this._registerCharts();
        
        // setup the button tabs
        this._registerTabs();
        
        PortalHelper.debugMessage('Service Web and App Security Initialized');
    },
    
    // run the controller
    run: function()
    {
    
        // get and populate the order
        this._getOrder();
        
        if (this.zoneId == false) {
            this._getZones();
        } else {
            this._runOrder();
        }
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Web and App Security Controller Ran');
    },
    
    // this method runs all of the methods to populate a single order. This can be called by the initial run method if a zone id is provided in the URI. It can also be called from the getZones method if there is only a single zone.
    _runOrder: function()
    {
        $('#dd-order-container').removeClass('hidden');
        
        // get/populate the Draas specific order info
        this._getDdOrder();
        
        // get the ddos stats 
        this._getDdStats();
        
        // get the top threat countries
        this._getDdThreatCountries();
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the base order id
        if (segments.length >= 1) {
            this.baseOrderId = segments[0];
        }
        // set the zone id
        if (segments.length == 2) {
            this.zoneId = segments[1];
        }
        if (segments.length == 0) {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceDdController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );
            
            PortalMain.ServiceDdController._updateSelectedRange(this);
        });
        
        // expand or minimize the dns values
        $('#dns-table').on('click', '.value .show-dns-value', function(){
            $('.short-value', $(this).parent()).addClass('hidden');
            $(this).addClass('hidden');
            $('.long-value', $(this).parent()).removeClass('hidden');
            $('.hide-dns-value', $(this).parent()).removeClass('hidden');
        });
        
        $('#dns-table').on('click', '.value .hide-dns-value', function(){
            $('.short-value', $(this).parent()).removeClass('hidden');
            $('.show-dns-value', $(this).parent()).removeClass('hidden');
            $('.long-value', $(this).parent()).addClass('hidden');
            $(this).addClass('hidden');
        });
    },
    
    // register the chart
    _registerCharts: function()
    {
        // pie chart for ssl trafic
        var sslChart = new PortalChart;
        sslChart.elementId = 'ssl-chart';
        sslChart.type = 'donut';
        sslChart.dataFormat = 'number';
        this.sslChart = sslChart;
        
        // new chart for vm count history
        var visitorsChart = new PortalChart;
        visitorsChart.elementId = 'visitors-chart';
        visitorsChart.type = 'line';
        visitorsChart.dataFormat = 'number';
        visitorsChart.columns = [];
        this.visitorsChart = visitorsChart;
    },
    
    // setup the tabs
    _registerTabs: function()
    {
        var buttonTabs = new PortalButtonTabs;
        buttonTabs.tabClickCallback = PortalMain.ServiceDdController._tabClickCallback;
        buttonTabs.init('.button-tabs');
    },
    
    // redraw the charts to fill the now visible space
    _tabClickCallback: function(tabTarget)
    {
        PortalMain.ServiceDdController.visitorsChart.draw();
        PortalMain.ServiceDdController.sslChart.draw();
    },
    
    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // get DDoS Protection zones
    _getZones: function()
    {
        var ddZonesRequest = new PortalRequest;
        ddZonesRequest.errorElement = '.order-fail';
        ddZonesRequest.makeRequest(
            '/orders-dd/get-dd-zones',
            {
                baseOrderId: this.baseOrderId,
            },
            function(data) {
                
                if (data.length > 1) {
                    $('#zones-container').removeClass('hidden');
                    PortalMain.ServiceDdController._populateZones(data);
                } else {
                    PortalMain.ServiceDdController.zoneId = data[0].zone_id;
                    PortalMain.ServiceDdController._runOrder();
                }
            },
            function() {
                // no dd order found, so hide the content
                $('#dd-content').addClass('hidden');
            }
        )
    },
    
    // populate 
    _populateZones: function(zones)
    {    
        // add the new dns records
        for (var i in zones) {
            var zone = zones[i];
            
            var newEntry = $('#zones-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the name
            $('.zone-name', newEntry).html(zone.name);
            
            // apply the zone link
            var zoneLink = PortalConfig.portalUrl;
            zoneLink += '/service/dd';
            zoneLink += '/' + this.baseOrderId;
            zoneLink += '/' + zone.zone_id;
            $('.zone-name', newEntry).attr('href', zoneLink);
            
            // apply the threats stopped
            var threats = PortalHelper.numberWithCommas(zone.threats_stopped);
            $('.zone-threats-stopped', newEntry).html(threats);
            
            // apply the requests
            var requests = PortalHelper.numberWithCommas(zone.requests_total);
            $('.zone-requests', newEntry).html(requests);
            
            // apply the visitors
            var visitors = PortalHelper.numberWithCommas(zone.unique_visitors);
            $('.zone-visitors', newEntry).html(visitors);
            
            // apply the bandwidth
            var bandwidthTotal = PortalHelper.formatBytes(zone.bandwidth_total);
            $('.zone-bandwidth', newEntry).html(bandwidthTotal);
            
            // add to to the table
            $('#zones-table tbody').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#zones-table', false);
    },
    
    // get DDoS Protection specific order info (usage information)
    _getDdOrder: function()
    {
        var ddOrderRequest = new PortalRequest;
        ddOrderRequest.errorElement = '.order-fail';
        ddOrderRequest.makeRequest(
            '/orders-dd/get-order-dd',
            {
                baseOrderId: this.baseOrderId,
                zoneId: this.zoneId,
            },
            function(data) {
                PortalMain.ServiceDdController._populateDdOrderInfo(data);
                PortalMain.ServiceDdController._populateTopThreatTypes(data);
                PortalMain.ServiceDdController._populateDnsRecords(data.usage.cloudflare_dns_records);
                PortalMain.ServiceDdController._populateFirewallEvents(data.usage.cloudflare_firewall_events);
                PortalMain.ServiceDdController._populateSslChart(data);
            },
            function() {
                // no dd order found, so hide the content
                $('#dd-content').addClass('hidden');
            }
        )
    },
    
    // populate document with usage information
    _populateDdOrderInfo: function(ddInfo)
    {
        // set the threats stopped
        $('#threats-stopped').text(ddInfo.usage30Day.threats_stopped);
        
        // set the requests total
        var requestsTotal = PortalHelper.numberWithCommas(ddInfo.usage30Day.requests_total);
        $('#requests-total').text(requestsTotal);
        
        // set the requests cached
        var requestsCached = PortalHelper.numberWithCommas(ddInfo.usage30Day.requests_cached);
        $('#requests-cached').text(requestsCached);
        
        // set the requests uncached
        var requestsUncached = PortalHelper.numberWithCommas(ddInfo.usage30Day.requests_uncached);
        $('#requests-uncached').text(requestsUncached);
        
        // set the bandwidth total
        var bandwidthTotal = PortalHelper.formatBytes(ddInfo.usage30Day.bandwidth_total);
        $('#bandwidth-total').text(bandwidthTotal[0]);
        $('#bandwidth-total-unit').text(bandwidthTotal[1]);
        
        // set the bandwidth cached
        var bandwidthCached = PortalHelper.formatBytes(ddInfo.usage30Day.bandwidth_cached);
        $('#bandwidth-cached').text(bandwidthCached[0]);
        $('#bandwidth-cached-unit').text(bandwidthCached[1]);
        
        // set the bandwidth uncached
        var bandwidthUncached = PortalHelper.formatBytes(ddInfo.usage30Day.bandwidth_uncached);
        $('#bandwidth-uncached').text(bandwidthUncached[0]);
        $('#bandwidth-uncached-unit').text(bandwidthUncached[1]);
        
        
        PortalHelper.loadingOverlay('.stats', false);
        
    },
    
    // populate document with usage information
    _populateTopThreatTypes: function(ddInfo)
    {
        if (ddInfo.usage.cloudflare_threat_types_top5.length <= 0) {
            $('#threat-type-list').html('');
            $('#threat-type-list').html('There are no threats within this time period.');
            PortalHelper.loadingOverlay('#threat-type-list', false);
            return;
        }
            
        // add the new dns records
        for (var i in ddInfo.usage.cloudflare_threat_types_top5) {
            var threatType = ddInfo.usage.cloudflare_threat_types_top5[i];
            
            var newEntry = $('#threat-type-list .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the threat type
            var threatName = 'Unknown';
            if (this.threatTypes.hasOwnProperty(threatType.threat_type)) {
                threatName = this.threatTypes[threatType.threat_type];
            }
            $('.item', newEntry).html(threatName);
            
            // apply the amount
            var amount = PortalHelper.numberWithCommas(threatType.amount);
            $('.count', newEntry).html(amount);
            
            // add to to the table
            $('#threat-type-list .count-list').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#threat-type-list', false);
    },
    
    
    // populate dns records
    _populateDnsRecords: function(dnsRecords)
    {
        // what to prepend to the values based on the dns type
        var prependValue = {
            a: 'points to ',
            cname: 'is alias of ',
            mx: 'mail handled by ',
            ns: 'managed by ',
            srv: 'SRV ',
            txt: ''
        };
        
        // add the new dns records
        for (var i in dnsRecords) {
            var dnsRecord = dnsRecords[i];
            
            var newEntry = $('#dns-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the record type
            $('.record-type', newEntry).html(dnsRecord.dns_type);
            
            // apply the vm name
            var name = dnsRecord.dns_name.replace('.' + dnsRecord.zone_name, '');
            $('.dns-name', newEntry).html(name);
            
            // apply the value, and set the proper display given the length
            var content = dnsRecord.content;
            content = prependValue[dnsRecord.dns_type.toLowerCase()] + content;
            $('.value .long-value', newEntry).html(content);
            if (content.length > 50) {
                content = content.substring(0, 50) + '...';
                $('.value .short-value', newEntry).html(content);
                $('.value .long-value', newEntry).addClass('hidden');
                $('.value .hide-dns-value', newEntry).addClass('hidden');
                
            } else {
                $('.value .short-value', newEntry).addClass('hidden');
                $('.value .show-dns-value', newEntry).addClass('hidden');
                $('.value .hide-dns-value', newEntry).addClass('hidden');
            }
            
            // apply the proxied
            var proxyClass = '';
            if (dnsRecord.dns_type == 'A' || dnsRecord.dns_type == 'CNAME') {
                if (dnsRecord.proxied) {
                    proxyClass = 'status-indicator--green';
                } else {
                    proxyClass = 'status-indicator--red';
                }
            }
            $('.proxied .status-indicator', newEntry).addClass(proxyClass);
            
            // add to to the table
            $('#dns-table tbody').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#dns-table', false);
    },
    
    
    // populate dns records
    _populateFirewallEvents: function(firewallEvents)
    {
        // add the new dns records
        for (var i in firewallEvents) {
            var firewallEvent = firewallEvents[i];
            
            var newEntry = $('#firewall-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the action
            var action = firewallEvent.action.charAt(0).toUpperCase() + firewallEvent.action.slice(1);
            $('.action', newEntry).html(action);
            
            // apply the IP address
            $('.ip', newEntry).html(firewallEvent.ip);
            
            // apply the country
            $('.country', newEntry).html(firewallEvent.country_name);
            
            // apply the host
            $('.host', newEntry).html(firewallEvent.host);
            
            // add to to the table
            $('#firewall-table tbody').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#firewall-table', false);
    },
    
    // plug the invoice products data into the chart
    _populateSslChart: function(data)
    {   
        
        // format the data for use in the chart
        var chartData = [
            ['Type', 'Amount'],
            ['Encrypted', parseInt(data.usage30Day.requests_encrypted)],
            ['Unencrypted', parseInt(data.usage30Day.requests_total) - parseInt(data.usage30Day.requests_encrypted)]
        ];
            
        this.sslChart.data = chartData;
        this.sslChart.draw();
        
        PortalHelper.loadingOverlay('#ssl-chart', false); 
    },
    
    // retrieves the timeline draas stats
    _getDdStats: function(startDate, endDate)
    {
        // defaulting to 1 month range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var ddStatsRequest = new PortalRequest;
        ddStatsRequest.makeRequest(
            '/orders-dd/get-dd-stats',
            {
                baseOrderId: this.baseOrderId,
                zoneId: this.zoneId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                
                if (data.length > 1) {
                    PortalMain.ServiceDdController._populateVisitorsChart(data, startDate, endDate);
                }
            }
        );
    },
    
    // sets up the unique visitors graph, populating columns and data
    _populateVisitorsChart: function(chartData, startDate, endDate)
    {    
        // keep only the specified columns for the chart
        chartData = PortalHelper.chartGetColumns(chartData, [
            'Time',
            'Unique Visitors'
        ]);
        
        this.visitorsChart.minDate = startDate;
        this.visitorsChart.maxDate = endDate;
        // resetting columns first
        this.visitorsChart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                this.visitorsChart.columns[i] = ['date', currentField];
            } else {
                this.visitorsChart.columns[i] = ['number', currentField];
            }
        }
        
        if(chartData.length == 1) {
            $('#visitors-chart').text("No data available for this period.");
        } else {
            this.visitorsChart.data = chartData;
            this.visitorsChart.draw();
        }
        PortalHelper.loadingOverlay('#visitors-chart', false);        
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#visitors-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        this._getDdStats(startDate, endDate);
    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },
    
    // retrieves the top country threats
    _getDdThreatCountries: function(startDate, endDate)
    {
        // defaulting to 1 month range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }
        
        var ddStatsRequest = new PortalRequest;
        ddStatsRequest.makeRequest(
            '/orders-dd/get-threat-countries',
            {
                baseOrderId: this.baseOrderId,
                zoneId: this.zoneId,
            },
            function(data) {
                PortalMain.ServiceDdController._populateTopCountries(data);
                
            }
        );
    },
    
    // populate document with top threat countries
    _populateTopCountries: function(threatCountries)
    {
        if (threatCountries.length <= 0) {
            $('#threat-country-list').html('');
            $('#threat-country-list').html('There are no threats within this time period.');
            PortalHelper.loadingOverlay('#threat-country-list', false);
            return;
        }
            
        // add the new dns records
        for (var i in threatCountries) {
            var threatCountry = threatCountries[i];
            
            var newEntry = $('#threat-country-list .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the country name
            $('.item', newEntry).html(threatCountry.country_name);
            
            // apply the amount
            var amount = PortalHelper.numberWithCommas(threatCountry.amount);
            $('.count', newEntry).html(amount);
            
            // add to to the table
            $('#threat-country-list .count-list').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#threat-country-list', false);
    },
}